export type ProgressStepsProps = {
  current: number;
  children: JSX.Element[];
};

export enum PROGRESS_STEP_CONST {
  TEST_ID = 'progress-step',
}
